(ns ycweb.app.pos.pricetags.pricetags
  (:require
   [rum.core :as rum]
   [ycweb.app.pos.menu :as menu]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.cards :as cards]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.header :as header]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.core :as yuc]))

;; DONE - These steps make better sense if split.
(def pricetag-steps
  (forms/setup-steps
    [{:key :start :title "Get Started"}
     {:key :labelset/config :title "Select Label Type"}
     {:key :labelset/scan :title "Scan Products"}
     {:key :labelset/print :title "Scan Printer"}
     {:key :labelset/finish :title "Finished"}]))

(def queue-steps
  (forms/setup-steps
    [{:key :start :title "Get Started"}
     {:key :queue :title "Confirm Queue"}
     {:key :queue/finish :title "Finished"}]))

(def reprint-steps
  (forms/setup-steps
    [{:key :start :title "Get Started"}
     {:key :reprint/select :title "Select Batch"}
     {:key :reprint/print :title "Scan Printer"}
     {:key :reprint/finish :title "Finished"}]))

(def label-type-order [:sticker :micro :compact :medium :mixed :barcodetemplate :smallwarehousesticker])
(def label-types
  {:sticker {:title "Product Stickers" :description "Price stickers on products"}
   :micro {:title "Micro Display Labels" :description "40mm wide shelf labels"}
   :compact {:title "Compact Display Labels" :description "89mm Simple shelf labels"}
   :medium {:title "Medium Display Labels" :description "120mm Shelf labels with rating info"}
   :mixed {:title "Mixed Display Labels" :description "Shelf labels, some compact, some medium"}
   :barcodetemplate {:title "Warehouse Barcode" :description "Warehouse barcode"}
   :smallwarehousesticker {:title "Small Warehouse Barcode" :description "Compact warehouse barcode"}})

(rum/defc pricetags-screen-wrapper
  [app-atom step-setup progress-step body foot-note call-to-action]

  (let [menu-atom (rum/cursor app-atom :menu)]
    [:div.page-body
     (header/header app-atom "Price Tags" {})
     (header/menu-overlay menu-atom)
     (header/menu app-atom (menu/select-menus app-atom))
     (into
       [:div.page-body__main-content
        [:div.section
         (forms/progress-steps
           (forms/progress-step step-setup progress-step))]]
       body)

     (toaster/loading-overlay app-atom :pos/printing)

     (into
       [:aside.page-body__footer]
       foot-note)
     call-to-action]))

(rum/defc pricetags-screen-start < rum/reactive
  [app-atom]
  (pricetags-screen-wrapper app-atom pricetag-steps :start
    [[:div.u-margin-top-24
      [:div {:class (u/bem :section [:medium])}
       [:nav
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "What would you like to do?"]
        [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
         {:style {:height "auto"}
          :on-click
          #(grid/dispatch-action app-atom :pricetags/labelset-start {})}
         [:span.tile__content
          [:span.tile__icon-wrapper
           [:i.tile__icon
            {:class (u/bem :icon [:2-2 :price-tag :large :block])}]]
          [:span.tile__text "Print Individual Label Set Or By Store Bay"]]]
        [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
         {:style {:height "auto"}
          :on-click
          #(grid/dispatch-action app-atom :pricetags/queue-start {})}
         [:span.tile__content
          [:span.tile__icon-wrapper
           [:i.tile__icon
            {:class (u/bem :icon [:2-2 :history :large :block])}]]
          [:span.tile__text "Print Label Queue"]]]
        [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
         {:style {:height "auto"}
          :on-click
          #(grid/dispatch-action app-atom :pricetags/reprint-batch-start {})}
         [:span.tile__content
          [:span.tile__icon-wrapper
           [:i.tile__icon
            {:class (u/bem :icon [:2-2 :refresh :large :block])}]]
          [:span.tile__text "Reprint Price Change Batch"]]]]]]]

    []

    []))

(defmethod flow/render-screen :pricetags [app-atom screen]
  (pricetags-screen-start app-atom))

(defmethod grid/action :pricetags/labelset-start [app-atom config _]
  (swap! app-atom
    #(-> %
       (assoc-in [:pricetags :labelset :type] :labelset)
       (update-in [:pricetags :cart] {})))
  (t/transition-next app-atom :pricetags/labelset-config))

(defmethod grid/action :pricetags/queue-start [app-atom config _]
  (toaster/open-toast app-atom :processing "Finding updated products" {})
  (swap! app-atom
    #(-> %
       (assoc-in [:pricetags :labelset :type] :queue)
       (update-in [:pricetags :cart] {})))
  (comms/send :pos/label-update-queue {})
  (t/transition-next app-atom :pricetags/queue))

(defmethod comms/receive :pos/label-queue [app-atom e]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:pricetags :cart :items] (:items e)))

(defmethod comms/receive :pos/price-change [app-atom e]
  (swap! app-atom assoc-in [:alerts :price-change :qty] (:qty e)))

(rum/defc pricetags-screen-labelset-config < rum/reactive
  [app-atom]
  (let [pricetags-atom (rum/cursor-in app-atom [:pricetags :labelset])]
    (pricetags-screen-wrapper app-atom pricetag-steps :labelset/config
      [[:div.u-margin-top-24
        (into
          [:div {:class (u/bem :section [:medium])}
           [:h2.u-text-center {:class (u/bem :heading [:standard])}
            "Select Label Type to Print"]]
          (map
            (fn [k]
              (let [{:keys [title description]} (get label-types k)]
                [:div.form-field
                 (forms/radio title k (rum/cursor pricetags-atom :label-type)
                   {:description description})]))

            label-type-order))]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when (u/presence (cmn/curact pricetags-atom :label-type))
           #(t/transition-next app-atom :pricetags/labelset-scan))}))))

(defmethod flow/render-screen :pricetags/labelset-config [app-atom screen]
  (pricetags-screen-labelset-config app-atom))

(defn collate-items [items]
  (->>
    (reduce
      (fn [acc i]
        (update acc
          [(:vid i) (:labeltype i)]
          (fnil
            #(-> %
               (update :qty (fnil inc 0))
               (update :ids conj (:cartitem_id i)))
            (dissoc i :qty))))
      {}
      items)
    vals
    (sort-by (comp u/dt-millis :dateadded))
    reverse))

(rum/defc render-cart < rum/reactive [{:keys [remove-item-fn]} cart-atom]
  (let [items (collate-items (cmn/curact cart-atom :items))]
    (cond
      (not (empty? items))
      [:div.slats
       (map
         (fn [i]
           (cards/product-slat
             {:options-fn
              #(remove-item-fn i)
              :option-icon :delete
              :option-limited true} i))
         (reverse items))]
      :else
      [:div {:class (u/bem :section [:medium])}
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "Scan Individual Products Or A Bay From The Store Plan"]
       [:div
        [:i.u-block-center
         {:class
          (u/bem
            :icon
            [:2-1 :barcode-scan :light-force :enormous :block])}]]])))

(rum/defc render-queue-cart < rum/reactive [{:keys [remove-item-fn]} cart-atom]
  (let [items
        (group-by :labeltype (collate-items (cmn/curact cart-atom :items)))]
    (cond
      (not (empty? items))
      (into
        [:div.slats]
        (mapcat
          (fn [[k is]]
            (into
              [[:h3.heading-slat {:class (u/bem :slat [:muted])} (get-in label-types [(keyword k) :title])]]
              (map
                (fn [i]
                  (cards/product-slat
                    {:options-fn
                     #(remove-item-fn i)
                     :option-icon :delete
                     :option-limited true} i))
                is)))
          items))
      :else
      [:div {:class (u/bem :section [:medium])}
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "No labels need updating"]
       [:div
        [:i.u-block-center
         {:class
          (u/bem
            :icon
            [:2-1 :success :light-force :enormous :block])}]]])))

;; ========= Barcode Modal ===========================
(rum/defc barcode-modal-body < rum/reactive [app-atom config-atom]
  [:div
   [:h3
    {:class (u/bem :heading [:medium-large])}
    "Capture manual barcode"]
   (forms/input "Barcode:" "" (rum/cursor config-atom :scan) {:type :barcode :auto-focus (cmn/auto-focus? app-atom)})])

(rum/defc barcode-modal-footer [app-atom config-atom]
  (grid/button-row
    {:left-text "Cancel"
     :left-no-icon true
     :left-fn #(grid/dispatch-modal-action app-atom :pricetags/labelset-barcode-cancel)
     :right-text "Capture"
     :right-no-icon true
     :right-fn #(grid/dispatch-modal-action app-atom :pricetags/labelset-barcode)}))

(defmethod grid/modal-config :pricetags/modal-barcode [_ _ _]
  {:body barcode-modal-body
   :footer barcode-modal-footer
   :modal-type :alert})

(defn barcode-modal [app-atom]
  (grid/open-modal app-atom :pricetags/modal-barcode {:scan ""}))

(defn label-header [pricetags-atom]
  (get-in label-types [(keyword (cmn/curact pricetags-atom :label-type)) :title]))

(rum/defc pricetags-screen-labelset-scan < rum/reactive
  [app-atom]
  (let [remove-item-fn
        #(grid/dispatch-action app-atom :pricetags/labelset-delete %)

        pricetags-atom (rum/cursor-in app-atom [:pricetags :labelset])
        cart-atom (rum/cursor-in app-atom [:pricetags :cart])]
    (pricetags-screen-wrapper app-atom pricetag-steps :labelset/scan
      [[:div.u-margin-top-24
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Products for " (label-header pricetags-atom)]]
        (render-cart {:remove-item-fn remove-item-fn} cart-atom)]]

      [[:p.paragraph.paragraph--flush.u-text-center.u-margin-top-24
        [:a.text-link
         {:on-click
          #(barcode-modal app-atom)}
         "Add Product Barcode Or Bay Name Manually"]]]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when-not (empty? (cmn/curact cart-atom :items))
           #(t/transition-next app-atom :pricetags/labelset-print))}))))

(defmethod flow/render-screen :pricetags/labelset-scan [app-atom screen]
  (pricetags-screen-labelset-scan app-atom))

(defmethod flow/barcode-dispatch-screen :pricetags/labelset-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :pricetags/labelset-barcode {:scan scan}))

(defmethod grid/action :pricetags/labelset-barcode [app-atom config _]
  (let [{:keys [labelset]} (:pricetags @app-atom)]
    (toaster/open-subtle-progress app-atom)
    (comms/send :pos/label-scan
      {:scan (:scan config)
       :labeltype (:label-type labelset)})))

(defmethod comms/receive :pos/label-scan-result [app-atom e]
  (toaster/close-subtle-progress app-atom)
  #?(:cljs
     (.setTimeout js/window
       (fn []
         (swap! app-atom update-in [:pricetags :cart :items]
           #(map
              (fn [i]
                (if (= (:id i) (get-in e [:item :id]))
                  (dissoc i :pulse-slat) i)) %)))
       1000))
  (if (:itemlist e)
    (swap! app-atom update-in [:pricetags :cart :items] concat
      (mapcat
        (fn [i]
          (repeat (:qty i)
            (->
              i
              (dissoc :qty)
              (assoc :dateadded (u/now)))))
        (:itemlist e)))
    (swap! app-atom update-in [:pricetags :cart :items] conj
      (assoc (:item e) :pulse-slat :add :dateadded (u/now)))))

(defmethod grid/action :pricetags/labelset-delete [app-atom {:keys [barcode]} _]
  (swap! app-atom update-in [:pricetags :cart :items]
    #(remove (comp #{barcode} :barcode) %)))

(rum/defc pricetags-screen-labelset-print < rum/reactive
  [app-atom]
  (let [pricetags-atom (rum/cursor-in app-atom [:pricetags :labelset])]
    (pricetags-screen-wrapper app-atom pricetag-steps :labelset/print
      [[:div.u-margin-top-24

        ;;TODO - listen for scan and send to the fake server!
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Print " (label-header pricetags-atom)]
         [:i.u-block-center {:class (u/bem :icon [:block :enormous :printer :3-3])}]]]]

      [[:p.paragraph.paragraph--flush.u-text-center
        "Scan printer to print labels"]]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Printer"
         :right-plain true}))))

(defmethod flow/render-screen :pricetags/labelset-print [app-atom screen]
  (pricetags-screen-labelset-print app-atom))

(defmethod flow/barcode-dispatch-screen :pricetags/labelset-print [_ app-atom scan]
  (grid/dispatch-action app-atom :pricetags/labelset-print-scan {:scan scan}))

(defmethod grid/action :pricetags/labelset-print-scan [app-atom {:keys [scan]}]
  (let [{:keys [labelset cart]} (:pricetags @app-atom)]
    (cond
      (and
        (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
        (or
          (= (:label-type labelset) :micro)
          (= (:label-type labelset) :compact)))
      (toaster/open-overlay app-atom :pos/printing
        {:text "Fetching Documents" :loading-text? false})

      :else
      (toaster/open-toast app-atom :processing "Fetching Documents" {}))

    (swap! app-atom assoc-in [:printers :scanned-printer] scan)

    (comms/send :pos/print-labels
      {:printername scan
       :batch_id (:batch_id cart)
       :type (:type labelset)
       :label-type (:label-type labelset)
       :cart (map #(select-keys % [:vid :barcode]) (:items cart))})))

(defmethod comms/receive :pos/labels-printed [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (let [{:keys [labelset]} (:pricetags @app-atom)
        scanned-printer (cmn/curact app-atom [:printers :scanned-printer])
        next-screen
        (if (= (:type e) :queue)
          :pricetags/queue-finish
          :pricetags/labelset-finish)]

    (swap! app-atom assoc-in [:pricetags :cart :batch_id] (:batch_id e))

    (cond
      (and
        (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
        (or
          (= (:label-type labelset) :micro)
          (= (:label-type labelset) :compact)))
      (swap! app-atom assoc-in [:printers scanned-printer :transition-to] next-screen)

      :else
      (do
        (toaster/open-toast app-atom :success "Printed" {})
        (t/transition-next app-atom next-screen)))))

(rum/defc pricetags-screen-labelset-finished < rum/reactive
  [app-atom]
  (let [pricetags-atom (rum/cursor-in app-atom [:pricetags :labelset])]
    (pricetags-screen-wrapper app-atom pricetag-steps :labelset/finish
      [[:div.u-margin-top-24

        ;;TODO - listen for scan and send to the fake server!
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Printed " (label-header pricetags-atom)]
         [:i.u-block-center {:class (u/bem :icon [:block :enormous :emoticon-happy :3-3])}]]]]

      [[:p.paragraph.paragraph--flush.u-text-center
        "Scan printer to reprint labels"]]

      (grid/pos-call-to-action
        {:single-fn
         #(grid/dispatch-action app-atom :pricetags/queue-finish-close
            {:printer (cmn/curact app-atom :printers)})}))))

(defmethod flow/render-screen :pricetags/labelset-finish [app-atom screen]
  (pricetags-screen-labelset-finished app-atom))

(defmethod flow/barcode-dispatch-screen :pricetags/labelset-finish [_ app-atom scan]
  (grid/dispatch-action app-atom :pricetags/labelset-print-scan {:scan scan}))

(defmethod grid/action :pricetags/labelset-finish-next [app-atom config _]
  (swap! app-atom update-in [:pricetags :labelset] {})
  (swap! app-atom update-in [:pricetags :cart] {})
  (t/transition-next app-atom :main-menu))

(rum/defc pricetags-screen-queue < rum/reactive
  [app-atom]
  (let [cart-atom (rum/cursor-in app-atom [:pricetags :cart])]
    (pricetags-screen-wrapper app-atom queue-steps :queue
      [[:div.u-margin-top-24

        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Queued products"]]
        (render-queue-cart
          {:remove-item-fn
           #(grid/dispatch-action app-atom :pricetags/tags-set-deleted {:label %})}
          cart-atom)]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text
         (if (empty? (cmn/curact cart-atom :items)) "" "Scan Printer")
         :right-plain true}))))

(defmethod flow/render-screen :pricetags/queue [app-atom screen]
  (pricetags-screen-queue app-atom))

(defmethod flow/barcode-dispatch-screen :pricetags/queue [_ app-atom scan]
  (grid/dispatch-action app-atom :pricetags/queue-print-scan {:scan scan}))

(defmethod grid/action :pricetags/queue-print-scan [app-atom {:keys [scan]} _]
  (toaster/open-toast app-atom :processing "Printing" {})
  (swap! app-atom assoc-in [:printers :scanned-printer] scan)
  (comms/send :pos/label-queue-print
    {:printername scan}))

(defmethod comms/receive :pos/label-queue-printed [app-atom e]
  (toaster/open-toast app-atom :success "Printed" {})
  (let [;; If we have a selected-batch, we're in the reprint flow
        reprint-flow? (get-in @app-atom [:pricetags :selected-batch])
        next-screen (if reprint-flow?
                      :pricetags/reprint-finish
                      :pricetags/queue-finish)]
    (t/transition-next app-atom next-screen))
  (swap! app-atom assoc-in [:pricetags :queue-labels] (:labelids e))
  (swap! app-atom assoc-in [:pricetags :queue-batch-id] (:batch_id e))
  (swap! app-atom assoc-in [:alerts :price-change :qty] 0))

(defmethod comms/receive :pos/pricechange-batches [app-atom e]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:pricetags :batches] (:batches e)))

(defmethod grid/action :pricetags/tags-set-deleted [app-atom {:keys [label]}]
  (toaster/open-toast app-atom :processing "Deleting label" {})
  (comms/send :pos/delete-label {:label label}))

(defmethod comms/receive :pos/label-deleted [app-atom {message :message {:keys [barcode]} :label}]
  (toaster/close-subtle-progress app-atom)
  (if message

    (toaster/open-toast app-atom :error message {})
    (do
      (toaster/open-toast app-atom :success "Deleted" {})
      (swap! app-atom update-in [:pricetags :cart :items]
        #(remove (comp #{barcode} :barcode) %)))))

(rum/defc pricetags-screen-queue-finished < rum/reactive
  [app-atom]
  (pricetags-screen-wrapper app-atom queue-steps :queue/finish
    [[:div.u-margin-top-24
      ;;TODO - listen for scan and send to the fake server!
      [:div {:class (u/bem :section [:medium])}
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "Updated labels printed"]
       [:i.u-block-center {:class (u/bem :icon [:block :enormous :emoticon-happy :3-3])}]]]]

    [[:p.paragraph.paragraph--flush.u-text-center
      "Scan printer to reprint labels"]]

    (grid/pos-call-to-action
      {:single-fn
       #(grid/dispatch-action app-atom :pricetags/queue-finish-close
          {:printer (cmn/curact app-atom :printers)})})))

(defmethod flow/render-screen :pricetags/queue-finish [app-atom screen]
  (pricetags-screen-queue-finished app-atom))

(rum/defc confirm-queue-finish-body [app-atom]
  (list
    (headings/heading "Are you sure?"
      {:type :h2
       :size :default})
    [:p.yc-paragraph
     "This will remove the labels from the queue.
      If the labels did not print, do not click finish."]))

(rum/defc confirm-queue-finish-footer [app-atom config-atom]
  (let [pricetags (cmn/curact app-atom :pricetags)
        printers (cmn/curact app-atom :printers)
        labelset (:labelset pricetags)]
    [[:div
      {:class (yuc/bem :flex-grid-group [:flush])}
      [:div
       {:class (yuc/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
       (buttons/button-web "Finish"
         {:type :button
          :on-click
          #(do
             (comms/send :pos/pricechange.finish
               {:batch_id (:batch_id (:cart pricetags))
                :labels (:queue-labels pricetags)
                :label-type (:label-type labelset)
                :printername (:scanned-printer printers)})
             (grid/close-modal app-atom))
          :style :primary
          :size :large
          :full true
          :persistent true
          :flat-style :flat})]

      [:div
       {:class (yuc/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
       (buttons/button-web "Cancel"
         {:type :button
          :on-click #(grid/close-modal app-atom)
          :style :secondary
          :size :large
          :full true
          :persistent true
          :flat-style :flat})]]]))

(defmethod comms/receive :pos/pricechange.finish [app-atom _]
  (t/transition-next app-atom :main-menu))

(defmethod grid/modal-config :pricetags/queue-finish-confirm [_ _ _]
  {:body confirm-queue-finish-body
   :footer confirm-queue-finish-footer
   :modal-type :variable})

(defmethod grid/action :pricetags/queue-finish-close [app-atom config _]
  (grid/open-modal app-atom :pricetags/queue-finish-confirm config))

(defmethod flow/barcode-dispatch-screen :pricetags/queue-finish [_ app-atom scan]
  (grid/dispatch-action app-atom :pricetags/queue-reprint-scan {:scan scan}))

(defmethod grid/action :pricetags/queue-reprint-scan [app-atom {:keys [scan]} _]
  (toaster/open-toast app-atom :processing "Reprinting" {})
  (comms/send :pos/label-queue-reprint
    {:printername scan :labelids (get-in @app-atom [:pricetags :queue-labels])}))

;; ========= Reprint Batch Flow ===========================

(defmethod grid/action :pricetags/reprint-batch-start [app-atom config _]
  (toaster/open-toast app-atom :processing "Loading batches" {})
  (swap! app-atom assoc-in [:pricetags :batches] nil)
  (swap! app-atom assoc-in [:pricetags :selected-batch] nil)
  (comms/send :pos/list-pricechange-batches {})
  (t/transition-next app-atom :pricetags/reprint-select))

(defn format-batch-time [dateadded]
  #?(:cljs
     (when dateadded
       (let [d (js/Date. dateadded)]
         (str (.toLocaleDateString d) " " (.toLocaleTimeString d))))
     :clj (str dateadded)))

(rum/defc render-batch-list < rum/reactive [app-atom]
  (let [batches (cmn/curact app-atom [:pricetags :batches])
        selected-batch (cmn/curact app-atom [:pricetags :selected-batch])]
    (cond
      (nil? batches)
      [:div {:class (u/bem :section [:medium])}
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "Loading batches..."]]

      (empty? batches)
      [:div {:class (u/bem :section [:medium])}
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "No price change batches found"]
       [:div
        [:i.u-block-center
         {:class (u/bem :icon [:2-1 :info :light-force :enormous :block])}]]]

      :else
      [:div.slats
       (map
         (fn [batch]
           [:div.slat
            {:class (when (= (:id batch) (:id selected-batch)) "slat--selected")
             :on-click #(swap! app-atom assoc-in [:pricetags :selected-batch] batch)}
            [:div.slat__content
             [:div.slat__primary
              [:span.slat__title
               (str (:firstname batch) " " (:lastname batch))]
              [:span.slat__subtitle
               (format-batch-time (:dateadded batch))]]
             [:div.slat__secondary
              [:span.slat__meta
               (str (:label_count batch) " labels")]
              (when (:printername batch)
                [:span.slat__meta
                 (str "Printer: " (:printername batch))])]]])
         batches)])))

(rum/defc pricetags-screen-reprint-select < rum/reactive
  [app-atom]
  (let [selected-batch (cmn/curact app-atom [:pricetags :selected-batch])]
    (pricetags-screen-wrapper app-atom reprint-steps :reprint/select
      [[:div.u-margin-top-24
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Select a batch to reprint"]]
        (render-batch-list app-atom)]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when selected-batch
           #(t/transition-next app-atom :pricetags/reprint-print))}))))

(defmethod flow/render-screen :pricetags/reprint-select [app-atom screen]
  (pricetags-screen-reprint-select app-atom))

(rum/defc pricetags-screen-reprint-print < rum/reactive
  [app-atom]
  (let [selected-batch (cmn/curact app-atom [:pricetags :selected-batch])]
    (pricetags-screen-wrapper app-atom reprint-steps :reprint/print
      [[:div.u-margin-top-24
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Reprint " (:label_count selected-batch) " labels"]
         [:p.u-text-center
          (str "From " (format-batch-time (:dateadded selected-batch)))]
         [:i.u-block-center {:class (u/bem :icon [:block :enormous :printer :3-3])}]]]]

      [[:p.paragraph.paragraph--flush.u-text-center
        "Scan printer to reprint labels"]]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Printer"
         :right-plain true}))))

(defmethod flow/render-screen :pricetags/reprint-print [app-atom screen]
  (pricetags-screen-reprint-print app-atom))

(defmethod flow/barcode-dispatch-screen :pricetags/reprint-print [_ app-atom scan]
  (grid/dispatch-action app-atom :pricetags/reprint-batch-scan {:scan scan}))

(defmethod grid/action :pricetags/reprint-batch-scan [app-atom {:keys [scan]} _]
  (let [selected-batch (get-in @app-atom [:pricetags :selected-batch])]
    (toaster/open-toast app-atom :processing "Reprinting batch" {})
    (swap! app-atom assoc-in [:printers :scanned-printer] scan)
    (comms/send :pos/label-queue-reprint
      {:printername scan
       :batch_id (:id selected-batch)})))

(rum/defc pricetags-screen-reprint-finished < rum/reactive
  [app-atom]
  (let [selected-batch (cmn/curact app-atom [:pricetags :selected-batch])]
    (pricetags-screen-wrapper app-atom reprint-steps :reprint/finish
      [[:div.u-margin-top-24
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Batch reprinted"]
         [:i.u-block-center {:class (u/bem :icon [:block :enormous :emoticon-happy :3-3])}]]]]

      [[:p.paragraph.paragraph--flush.u-text-center
        "Scan printer to reprint again"]]

      (grid/pos-call-to-action
        {:single-fn #(do
                       (swap! app-atom assoc-in [:pricetags :selected-batch] nil)
                       (t/transition-next app-atom :pricetags))}))))

(defmethod flow/render-screen :pricetags/reprint-finish [app-atom screen]
  (pricetags-screen-reprint-finished app-atom))

(defmethod flow/barcode-dispatch-screen :pricetags/reprint-finish [_ app-atom scan]
  (grid/dispatch-action app-atom :pricetags/reprint-batch-scan {:scan scan}))